import { render, staticRenderFns } from "./IsoscelesTrapezoid.vue?vue&type=template&id=bd5294b6&scoped=true"
import script from "./IsoscelesTrapezoid.vue?vue&type=script&lang=js"
export * from "./IsoscelesTrapezoid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5294b6",
  null
  
)

export default component.exports